import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import LoginForm from "../components/auth/LoginForm";
import AuthShell from "../components/auth/AuthShell";

function LoginPage({ onLogin, goToRegister, inviteContext }) {
  return (
    <AuthShell
      background="linear-gradient(180deg, #f3f6fa 0%, #eaf0f7 100%)"
      heroBackground="linear-gradient(180deg, #0c1a2e 0%, #102544 100%)"
      formBackground="linear-gradient(180deg, rgba(255,255,255,0.94) 0%, rgba(250,252,255,0.98) 100%)"
      heroTone="dark"
      heroBadge="Daily action · accountability · recovery"
      heroTitle="Stay connected to what matters."
      heroBody="TrustBud helps you keep a real goal visible, catch yourself when you go quiet, and get back in with one small step."
      heroBullets={[
        "A clear next habit",
        "One meaningful accountability relationship",
        "Low-pressure restart prompts when you begin to slip",
      ]}
      heroNote="Open TrustBud, see the next action, and get back into the loop."
      eyebrow="Welcome back"
      title="Log in and get back in."
      body="Pick up where you left off and see the next small move that matters."
      maxWidth={980}
    >
      {inviteContext?.valid ? (
        <Box
          sx={{
            p: 2,
            borderRadius: "8px",
            backgroundColor: "#f3f7fc",
            border: "1px solid #d9e4f2",
          }}
        >
          <Typography variant="body2" fontWeight={700} sx={{ color: "#1e3553" }}>
            {inviteContext.inviter
              ? `You were invited by ${inviteContext.inviter}.`
              : "You were invited to join TrustBud."}
          </Typography>
          <Typography variant="body2" sx={{ color: "#617086", mt: 0.5 }}>
            Accepting this invite will connect you after signup.
          </Typography>
        </Box>
      ) : null}

      <LoginForm onLogin={onLogin} />

      <Button
        component={RouterLink}
        to="/forgot-password"
        fullWidth
        sx={{ textTransform: "none", color: "#39557e", fontWeight: 600 }}
      >
        Forgot password?
      </Button>

      <Box
        sx={{
          pt: 2,
          borderTop: "1px solid #e4eaf1",
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "stretch", sm: "center" },
          justifyContent: "space-between",
          gap: 1.5,
        }}
      >
        <Typography variant="body2" sx={{ color: "#5f6978" }}>
          New here? Start with one account and one real goal.
        </Typography>
        <Button
          variant="outlined"
          onClick={goToRegister}
          sx={{
            textTransform: "none",
            borderRadius: "8px",
            px: 2,
            fontWeight: 700,
          }}
        >
          Create an account
        </Button>
      </Box>
    </AuthShell>
  );
}

export default LoginPage;
